import { DesignTokens } from '@givelify/ui';
import { styled } from '@mui/material';

const LEFT_LIMIT = 15;
const RIGHT_LIMIT = 85;

export const Wrapper = styled('div')({
    height: 26,
    position: 'relative',
});

export const ProgressTooltipContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'position',
})<{ disabled: boolean; position: number }>(({ disabled, position }) => ({
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    paddingLeft: 4,
    paddingRight: 4,
    whiteSpace: 'nowrap',
    position: 'absolute',
    top: 2,
    backgroundColor: disabled
        ? DesignTokens.color.backgroundComponentSecondary
        : DesignTokens.color.backgroundComponentTertiary,
    left: `${
        position < LEFT_LIMIT ? 0 : position > RIGHT_LIMIT ? 100 : position
    }%`,
    transform:
        position < LEFT_LIMIT
            ? undefined
            : position > RIGHT_LIMIT
            ? 'translate(-100%, 0)'
            : 'translate(-50%, 0)',
}));
